/**
 * Action-type константы для модуля slides.
 *
 * Вынесены в отдельный файл от `action.js`, чтобы reducer (и его unit-тесты)
 * могли импортировать только строки-типы без транзитивного подтягивания
 * api-клиента (`@api` alias) — иначе jest-резолвер падает в jest-окружении,
 * см. `__tests__/reducer.spec.js`.
 */

export const FETCH_SLIDES_START = 'FETCH_SLIDES_START';
export const FETCH_SLIDES_SUCCESS = 'FETCH_SLIDES_SUCCESS';
export const FETCH_SLIDES_FAIL = 'FETCH_SLIDES_FAIL';

export const FETCH_SLIDE_START = 'FETCH_SLIDE_START';
export const FETCH_SLIDE_SUCCESS = 'FETCH_SLIDE_SUCCESS';
export const FETCH_SLIDE_FAIL = 'FETCH_SLIDE_FAIL';

export const CREATE_SLIDE_START = 'CREATE_SLIDE_START';
export const CREATE_SLIDE_SUCCESS = 'CREATE_SLIDE_SUCCESS';
export const CREATE_SLIDE_FAIL = 'CREATE_SLIDE_FAIL';

export const UPDATE_SLIDE_START = 'UPDATE_SLIDE_START';
export const UPDATE_SLIDE_SUCCESS = 'UPDATE_SLIDE_SUCCESS';
export const UPDATE_SLIDE_FAIL = 'UPDATE_SLIDE_FAIL';

export const DELETE_SLIDE_START = 'DELETE_SLIDE_START';
export const DELETE_SLIDE_SUCCESS = 'DELETE_SLIDE_SUCCESS';
export const DELETE_SLIDE_FAIL = 'DELETE_SLIDE_FAIL';

export const SET_SLIDE_VISIBILITY_SUCCESS = 'SET_SLIDE_VISIBILITY_SUCCESS';
export const REORDER_SLIDES_LOCAL = 'REORDER_SLIDES_LOCAL';
